<template>
  <section class="max-w-[1440px] mx-auto px-12 py-12 space-y-12">

    <!-- HEADER -->
    <header class="flex items-end justify-between">
      <div>
        <h2 class="text-4xl font-black tracking-tight">
          Interested Influencers
        </h2>
        <p class="text-slate-400 mt-2 max-w-2xl">
          Compare and evaluate creators selected for your campaign.
        </p>
      </div>

      <button
        v-if="shortlist.length"
        class="text-xs font-bold uppercase tracking-wider
               border-b-2 border-slate-900"
      >
        Compare →
      </button>
    </header>

    <!-- EMPTY STATE -->
    <div
      v-if="!shortlist.length"
      class="bg-white p-16 rounded-[2.5rem] premium-shadow
             border border-slate-50 text-center"
    >
      <h3 class="text-2xl font-bold text-slate-900">
        Your interested list is empty
      </h3>
      <p class="text-slate-400 mt-2">
        Add influencers from discovery to start comparing.
      </p>

      <button
        class="mt-6 bg-primary text-white px-10 py-4 rounded-xl
               font-bold text-xs uppercase tracking-wider"
      >
        Discover Influencers
      </button>
    </div>

    <!-- SHORTLIST GRID -->
    <section
      v-else
      class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8"
    >
      <div
        v-for="i in shortlist"
        :key="i.id"
        class="bg-white p-8 rounded-[2rem] premium-shadow
               border border-slate-50 flex flex-col justify-between"
      >
        <!-- HEADER -->
        <div>
          <div class="flex items-center gap-4 mb-4">
            <div
              class="size-12 rounded-full bg-slate-900 text-white
                     flex items-center justify-center font-black text-lg"
            >
              {{ i.name.charAt(0) }}
            </div>

            <div>
              <h4 class="font-bold text-slate-900">
                {{ i.name }}
              </h4>
              <p class="text-xs text-slate-400">
                {{ i.platform }} · {{ i.category }}
              </p>
            </div>
          </div>

          <!-- METRICS -->
          <div class="space-y-3 text-sm">
            <div class="flex justify-between">
              <span class="text-slate-400">Verified Fans</span>
              <strong>{{ i.verifiedFans }}</strong>
            </div>

            <div class="flex justify-between">
              <span class="text-slate-400">Trust Score</span>
              <strong class="text-right">
                {{ i.trustScore }}
              </strong>
            </div>

            <div class="flex justify-between">
              <span class="text-slate-400">Risk Score</span>
              <strong>{{ i.riskScore }}</strong>
            </div>
          </div>
        </div>

        <!-- ACTIONS -->
        <div class="mt-8 space-y-3">
          <button
            @click="gotoprofile(i.infId)"
            class="bg-primary text-white w-full py-3 rounded-xl
                   font-bold text-xs uppercase tracking-wider
                   hover:opacity-90 transition"
          >
            View Profile
          </button>

          <button
            @click="remove(i)"
            class="w-full py-3 rounded-xl border border-slate-200
                   text-xs font-bold uppercase tracking-wider
                   hover:bg-slate-50 transition text-red-600"
          >
            Remove
          </button>
        </div>
      </div>
    </section>

  </section>
</template>

<script>
import {
  loadShortlistApi,
  removeShortlistApi
} from "../apis/shortapis";

export default {
  name: "InterestedAc",

  data() {
    return {
      user_id: "",
      campaign_id: "",

      shortlist: []
    };
  },

  async mounted() {

    try {

      const ldataRaw = sessionStorage.getItem("ldata");

      if (ldataRaw && ldataRaw !== "undefined") {

        const ldata = JSON.parse(ldataRaw);

        if (ldata && ldata.user_id) {
          this.user_id = ldata.user_id;
        }
      }

    } catch (e) {

      console.log("Session parse error", e);
    }

    await this.loadShortlist();
  },

  methods: {

    gotoprofile(id) {
      window.location.href = "/agency/influencer-profile/"+id;
    },

    async loadShortlist() {

      const res = await loadShortlistApi({
        agency_id: this.user_id,
        campaign_id: this.campaign_id
      });

      if (res.status) {

        if (res.records && res.records.length) {

          this.shortlist = res.records.map(r => ({
            id: r.shortlist_id,
            infId:r.shortlist_influencer||"",
            name: r.shortlist_inf_name || "Unknown Creator",
            platform: r.shortlist_inf_platform || "-",
            category: r.shortlist_inf_category || "-",
            verifiedFans: r.verifiedFans || "0",
            trustScore: r.trustScore || "0",
            riskScore: r.riskScore || "0"
          }));

        } else {

          this.shortlist = []; // triggers empty UI
        }

      } else {

        console.log("Interest API failed");

        this.shortlist = [];
      }
    },

    async remove(id) {

      const res = await removeShortlistApi(this.user_id,id.infId);

      if (res.status) {
        this.loadShortlist();

      } else {

        console.log("Remove failed");
      }
    }
  }
};
</script>

<style scoped>
/* ===================================
   SHORTLIST – MOBILE RESPONSIVE PATCH
   =================================== */
@media (max-width: 640px) {

  /* Container padding fix (Tailwind override) */
  .px-12 {
    padding-left: 16px !important;
    padding-right: 16px !important;
  }

  .py-12 {
    padding-top: 24px !important;
    padding-bottom: 48px !important;
  }

  /* Header stack */
  header {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  header h2 {
    font-size: 26px !important;
    line-height: 1.2;
  }

  header p {
    font-size: 14px;
  }

  header button {
    align-self: flex-start;
    font-size: 11px;
    border-bottom-width: 1px;
  }

  /* Empty state */
  .p-16 {
    padding: 24px !important;
  }

  .p-16 h3 {
    font-size: 20px;
  }

  .p-16 p {
    font-size: 14px;
  }

  .p-16 button {
    width: 100%;
    padding: 14px 16px !important;
  }

  /* Grid tightening */
  .grid.md\\:grid-cols-2.xl\\:grid-cols-3 {
    gap: 16px;
  }

  /* Card padding + radius */
  .rounded-\\[2rem\\] {
    padding: 20px !important;
    border-radius: 20px !important;
  }

  /* Avatar */
  .size-12 {
    width: 40px !important;
    height: 40px !important;
    font-size: 16px !important;
  }

  /* Metrics text */
  .space-y-3 > div {
    font-size: 13px;
  }

  .space-y-3 strong {
    font-size: 13px;
  }

  /* Action buttons */
  .mt-8 {
    margin-top: 16px !important;
  }

  .mt-8 button {
    padding: 14px 16px !important;
    font-size: 11px;
  }
}

</style>